import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserResolver implements Resolve<Promise<boolean>> {
  async resolve(): Promise<boolean> {
    // UserResolver ensures auth state is initialized
    // Auth state is already being managed by AppComponent and AuthService
    // This resolver just ensures the private routes wait for auth to be ready
    return true;
  }
}
